import dayjs from "dayjs";

function formatDateTimeLocal(value) {
    return value ? dayjs(value).format("YYYY-MM-DDTHH:mm:ss") : null;
}

function normalizeDateTime(value) {
    return value ? dayjs(value).format("YYYY-MM-DD HH:mm:ss") : null;
}

function getDate(value) {
    return value ? dayjs(value).format("YYYY-MM-DD") : null
}


export {formatDateTimeLocal, normalizeDateTime, getDate}